import React, { useState, useEffect } from 'react';
import './AddCompany.css'

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AddCompany = () => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [formData, setFormData] = useState({
    companyName: '',
    companyLocation: '',
    internLimit: '',
    type: '',
  });

  useEffect(() => {
    // Fetch companies when the component mounts
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/organization/companies`);
      if (response.ok) {
        const data = await response.json();
        setCompanies(data);
      } else {
        console.error('Failed to fetch companies');
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  const handleEdit = (company) => {
    setSelectedCompany(company);
    setFormData({
      companyName: company.companyName,
      companyLocation: company.companyLocation,
      internLimit: company.internLimit,
      type: company.type,
    });
  };

  const handleDelete = async (companyId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/organization/companies/${companyId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        // Remove the deleted company from the state
        setCompanies((prevCompanies) => prevCompanies.filter((c) => c._id !== companyId));
      } else {
        console.error('Failed to delete company');
      }
    } catch (error) {
      console.error('Error deleting company:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let url = `${API_BASE_URL}/organization/new-company`;

      // If selectedCompany is not null, it means we are editing
      if (selectedCompany) {
        url = `${API_BASE_URL}/organization/companies/${selectedCompany._id}`;
      }

      const response = await fetch(url, {
        method: selectedCompany ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // Refresh the list of companies
        fetchCompanies();

        // Reset the form
        setFormData({
          companyName: '',
          companyLocation: '',
          internLimit: '',
          type: '',
        });

        // Clear the selectedCompany state
        setSelectedCompany(null);
      } else {
        console.error('Failed to save company');
      }
    } catch (error) {
      console.error('Error saving company:', error);
    }
  };

  return (
    <div className='form-flow'>
      <h1>Manage Institutions</h1>

      {/* Display the form for adding and editing companies */}
      <form className='form-flow' onSubmit={handleSubmit}>
        <h2>Add New Company</h2>
        <label>
          Company Name:
          <input
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
            required
          />
        </label>

        <label>
          Company Location:
          <input
            type="text"
            name="companyLocation"
            value={formData.companyLocation}
            onChange={(e) => setFormData({ ...formData, companyLocation: e.target.value })}
            required
          />
        </label>

        <label>
          Intern Limit:
          <input
            type="number"
            name="internLimit"
            value={formData.internLimit}
            onChange={(e) => setFormData({ ...formData, internLimit: e.target.value })}
            required
          />
        </label>

        {/* New field for type */}
        <label>
          Type:
          <select
            name="type"
            value={formData.type}
            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
            required
          >
            <option value="">Select Type</option>
            <option value="Research">Research</option>
            <option value="Health">Health</option>
          </select>
        </label>

        <button type="submit">{selectedCompany ? 'Edit Company' : 'Add Company'}</button>
      </form>
       
      {/* Display the list of companies */}
      <div className='form-flex'>
      <h3> Edit Company Information</h3>
      <ul className=''> 
        {companies.map((company) => (
         
          <li key={company._id}>
            <span className='company'>{company.companyName}</span>
            <button className='flex-btn btn' onClick={() => handleEdit(company)}>Edit</button>
            <button className='flex-btn btn'  onClick={() => handleDelete(company._id)}>Delete</button>
          </li>
         
        ))}
      </ul>
      </div>
    </div>
  );
};

export default AddCompany;
